import { languageApiSlice } from "src/api/v1/language-ApiSlice";
import { store } from "src/app/store";

/**
 * Translate function
 * @param {string} stringKey
 * @param {string} englishFallback
 * @param {{template: string, value: string}[]} replaceArr
 */
export function ts(
    stringKey: string,
    englishFallback: string,
    replaceArr?: { template: string, value: string }[]
): string {
  let baseString = getBaseString(stringKey, englishFallback);
  if (Array.isArray(replaceArr)) {
    replaceArr.forEach(elem => {
      baseString = baseString.replace(elem.template, elem.value);
    });
  }
  return baseString;
}

/**
 * Translate function.
 * ReplaceObj replaces "{KEY}" format templates in string
 * @example ts2("hello", "Hello {where}", {"where": "there"}) -> "Hello there"
 * @param {string} stringKey
 * @param {string} englishFallback
 * @param {Object.<string, string>} replaceObj
 */
export function ts2(
    stringKey: string,
    englishFallback: string,
    replaceObj: Record<string, string>
) {
  let baseString = getBaseString(stringKey, englishFallback);
  if (replaceObj) {
    for (let key in replaceObj) {
      baseString = baseString.replace('{' + key + '}', replaceObj[key]);
    }
  }
  return baseString;
}

function getBaseString(stringKey: string, englishFallback: string) {
  const result = languageApiSlice.endpoints.getLanguageMessages.select()(store.getState())
  const { data, isSuccess, isError, error } = result

  if (isSuccess) {
    return data?.[stringKey] ?? englishFallback;
  } else {
    return englishFallback
  }
}